import { Component, Emit, Prop, Vue } from 'vue-property-decorator'
import { AssaysViewSubportionResponse } from '@/components/assays-view/services/assays-view-subportion/assays-view-subportion.dto'
import {
    AssaysViewModalToolbarSummaryModelState,
    initialAssaysViewModalToolbarSummaryModelState
} from '@/components/assays-view/components/modal-toolbar-summary/assays-view-modal-toolbar-summary.model'

@Component
export default class AssaysViewModalToolbarSummary extends Vue {
    @Prop({ type: Number, default: 0 }) readonly subportionsTotal!: number

    @Prop({ type: Array, default: [] }) readonly subportionsPending!: AssaysViewSubportionResponse[]
    @Prop({ type: Array, default: [] }) readonly subportionsProgress!: AssaysViewSubportionResponse[]
    @Prop({ type: Array, default: [] }) readonly subportionsCompleted!: AssaysViewSubportionResponse[]
    @Prop({ type: Array, default: [] }) readonly subportionsCanceled!: AssaysViewSubportionResponse[]

    @Emit()
    showAllElements(): void { this.state.display = false }

    @Emit()
    hideAllElements(): void { this.state.display = true }

    state: AssaysViewModalToolbarSummaryModelState

    get subportionsTotalLabel(): string {
        const choice = this.subportionsTotal > 1 ? 2 : 1
        return `${this.subportionsTotal} ${this.$tc('global.techRequested', choice)}`
    }

    constructor() {
        super()
        this.state = initialAssaysViewModalToolbarSummaryModelState()
    }

    getProgressbarTooltip(subportions: AssaysViewSubportionResponse[]): string {
        return subportions.length
            ? subportions.length + ' ' + subportions[0].assayStatus.name
            : ''
    }
}
